import React from 'react';
import './PrincipalMessage.css';
import { useEffect } from 'react';
function PrincipalMessage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 
  return (
    <div className="pm-container">
      <div className="pm-section">
        <h2 className="pm-heading">Principal's Message</h2>
        <p className="pm-paragraph">
          Dear Students, Parents, and Staff,

        </p>
        <p>  

        </p>
        <p className="pm-paragraph">
          
          Welcome to Oxford Convent English Medium School, where excellence in
          education meets a nurturing environment for holistic growth. As we
          strive to create a space where learning thrives, we remain committed
          to shaping young minds into responsible, knowledgeable, and confident
          individuals.
        </p>
        <p className="pm-paragraph">
          At Oxford, we believe in providing more than just academic
          instruction. We aim to inspire curiosity, foster creativity, and
          promote critical thinking, all while instilling values of discipline,
          integrity, and respect. Our curriculum is designed to empower
          students with a comprehensive understanding of subjects, equipping
          them with the skills they need to succeed not only in academics but
          also in life.
        </p>
        <p className="pm-paragraph">
          Our dedicated team of educators works passionately to ensure that
          every student receives personalized attention, guidance, and
          encouragement to reach their fullest potential. We also emphasize the
          importance of co-curricular activities, which play a vital role in
          the development of a well-rounded personality.
        </p>
        <p className="pm-paragraph">
          At Oxford, we consider our parents as essential partners in the
          educational journey of our students. Together, we can provide the
          support and guidance necessary to help each child achieve their
          dreams.
        </p>
        <p className="pm-paragraph concluding-paragraph">
          We look forward to another successful year filled with growth,
          learning, and achievement.
        </p>
      </div>
    </div>
  );
}

export default PrincipalMessage;
